// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"7e1c1536","58":"9cea2f42","150":"515f5e84","152":"9d22e2e8","165":"c3b0fb7e","383":"3f96f39f","496":"9b3b75b4","533":"5b10ff86","605":"de8bc748","667":"c8d6e597","709":"fa137da0","766":"a61fd58e","796":"db174674","973":"256e8ada"}[chunkId] + ".chunk.js";
};